import { inject, Injectable } from '@angular/core';
import { FirebaseService } from '@fc-core/services/firebase.service';
import { PushService } from './push.service';

@Injectable()
export class WebPushService extends PushService {
  private firebaseService = inject(FirebaseService);

  init(): Promise<void> {
    return this.firebaseService.init();
  }
}
